export default __webpack_public_path__ + "static/media/130-sicily.fdfad80b.svg";